export default "__VITE_ASSET__vge0IY28__"